import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, AddCircleOutline, AddOutlined, ArrowBackIos, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRight, ArrowRightAltRounded, ArrowRightOutlined, CameraAltOutlined, CloseOutlined, CloseSharp, ExitToAppOutlined, KeyboardArrowRight, Send, Shield } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import CreateCommunityPopup from "../Utils/CreateCommunityPopup";
import AddUsersPopup from "../Utils/AddUsersPopup";
import searchIcon from '../../assets/search.svg'
import { MoonLoader } from 'react-spinners'
import AddEventPopup from "../Utils/AddEventPopup";
import SelectCommunitiesPopup from "../Utils/SelectCommunitiesPopup";

const CreatePostScreen = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMM, hh:mm a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });
    return formattedDate;
};
function CommunityListView({ data }) {
    const [userProfile, setUserProfile] = useState({})
    const navigate = useNavigate();
    const videoInputRef = useRef(null);
    const thumbInputRef = useRef(null)
    const canvasRef = useRef(null);
    const imageInputRef = useRef(null)
    const [vidCaption, setVidCaption] = useState("")
    const [selectedAccount, setSelectedAccount] = useState("id0")
    const [availableAccounts, setAvailableAccounts] = useState([
        { title: "Select an account", value: "id0" },
        { title: "Cerkle", value: "67e5aba171c9cf306deba6ef", image: "https://buzzprodbucket.blob.core.windows.net/user-content/Images/_1755757145263_442868_image" },
        { title: "Cerkle Campus", value: "687e531b776f7a67aaea73ac", image: "https://buzzprodbucket.blob.core.windows.net/user-content/Images/_1765378535336_794034_image" },
        { title: "Cerkle Support", value: "64f38b069d6424868558af4f", image: "https://buzzprodbucket.blob.core.windows.net/user-content/Images/_1773406264077_419175_image.png" },
        { title: "Rajat Ghosh", value: "68b6f497f776b4e8ce568be1", image: "https://buzzprodbucket.blob.core.windows.net/user-content/Images/_1767001048936_31746_image" },
        { title: "Shreya Chakrabarty", value: "69ba8818c4cb13bfefb351c4", image: "https://buzzprodbucket.blob.core.windows.net/user-content/Images/_1773832216466_197362_image.jpg" },
        // { title: "Rahul Prajapat", value: "638b5d18f5f2d2b79db8f1d4", image: "https://buzzcontentbucket.blob.core.windows.net/buzz-content-bucket/Images/_1729500228251_temp_file.jpg" }
    ])
    const [taggedUsers, setTaggedUsers] = useState([])
    const [showTaggedUserPopup, setShowTaggedUserPopup] = useState(false)
    const [searchedUsers, setSearchedUsers] = useState([])
    const [userQuery, setUserQuery] = useState("")
    const [eventQuery, setEventQuery] = useState("")
    const [taggedEvents, setTaggedEvents] = useState([])
    const [searchedEvents, setSearchedEvents] = useState([])
    const [showTaggedEventPopup, setShowTaggedEventPopup] = useState(false)
    const [showCMAddPopup, setShowCMAddPopup] = useState(false)
    const [communityQuery, setCommunityQuery] = useState("")
    const [searchedCommunities, setSearchedCommunities] = useState([])
    const [myCommunities, setMyCommunities] = useState([])
    const [selectedCommunities, setSelectedCommunities] = useState([])
    const [spaceEnabled, setSpaceEnabled] = useState(false)
    const [selectedVideo, setSelectedVideo] = useState(null)
    const spaceId = "699dbf8eee5400445a744563"//"691f36cae6244f837a97c1af"//
    const [selectedThumbnail, setSelectedThumbnail] = useState(null)
    const [selectedTab, setSelectedTab] = useState(0)
    const [videoDu, setVideoDu] = useState(0)
    const [loading, setLoading] = useState(false)
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (!userQuery) {
            setSearchedUsers([]);
            return;
        }

        const timer = setTimeout(async () => {
            searchUsers(userQuery)
        }, 300); // debounce

        return () => clearTimeout(timer);
    }, [userQuery]);


    useEffect(() => {

        if (!communityQuery) {
            setSearchedCommunities([]);
            return;
        }

        const timer = setTimeout(async () => {
            searchCommunity(communityQuery)
        }, 300); // debounce

        return () => clearTimeout(timer);

    }, [communityQuery]);


    useEffect(() => {
        if (!eventQuery) {
            setSearchedEvents([]);
            return;
        }

        const timer = setTimeout(async () => {
            searchEvent(eventQuery)
        }, 300); // debounce

        return () => clearTimeout(timer);
    }, [eventQuery]);

    const searchUsers = async (q) => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/user/s-u?q=${q}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSearchedUsers(data.data ?? [])
        } else {
            alert(data.response)
        }
    }

    const searchEvent = async (q) => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/events/search?q=${q}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSearchedEvents(data.data ?? [])
        } else {
            alert(data.response)
        }
    }


    const searchCommunity = async (q) => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/communities/search-in-mine?q=${q}&uid=${selectedAccount}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSearchedCommunities(data.data)
        } else {
            alert(data.response)
        }
    }

    const getMyCommunities = async (uid) => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/communities/my-all-communities?uid=${uid}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setMyCommunities(data.data)
        } else {
            alert(data.response)
        }
    }

    const handleChange = (e) => {
        const files = Array.from(e.target.files);

        if (files.length + images.length > 5) {
            alert("You can select up to 5 images only");
            return;
        }

        const selected = files.slice(0, 5 - images.length);

        setImages((prev) => [...prev, ...selected]);
    };

    const uploadLogo = async () => {

        try {
            if (!selectedVideo || !selectedThumbnail || !vidCaption || selectedAccount == "id0" || (selectedCommunities.length == 0 && !spaceEnabled)) {
                alert("Some of fields are empty or not selected")
                return
            }

            const taggedUserList = taggedUsers.map(tu => tu._id)
            const taggedEventList = taggedEvents.map(tu => tu._id)
            const selectedCommunitiesList = selectedCommunities.map(sc => sc._id)

            const formData = new FormData();
            formData.append("media", selectedVideo, selectedVideo.name);
            formData.append("thumbnail", selectedThumbnail, selectedThumbnail.name)
            formData.append("title", vidCaption);
            formData.append("taggedUsers", JSON.stringify(taggedUserList))
            formData.append("taggedEvents", JSON.stringify(taggedEventList));
            formData.append("communities", JSON.stringify(selectedCommunitiesList))
            formData.append("spaceId", spaceEnabled ? spaceId : "")
            formData.append("videoDuration", `${videoDu}`)
            formData.append("createdBy", selectedAccount)


            const token = localStorage.getItem("token");

            setLoading(true)

            const res = await fetch(`${BASE_URL}/uc/create-crisp`, {
                method: "POST",
                headers: {
                    "auth-token": token
                },
                body: formData
            });

            const data = await res.json();
            if (data.success) {
                alert(data.response)
            } else {
                alert(data.response);
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.error(error)
            alert("Something went wrong!")
        }

    };

    const uploadPost = async () => {

        try {
            if (!vidCaption || selectedAccount == "id0" || (selectedCommunities.length == 0 && !spaceEnabled)) {
                alert("Some of fields are empty or not selected")
                return
            }

            const taggedUserList = taggedUsers.map(tu => tu._id)
            const taggedEventList = taggedEvents.map(tu => tu._id)
            const selectedCommunitiesList = selectedCommunities.map(sc => sc._id)

            const formData = new FormData();

            if (images.length > 0) {
                for (let index = 0; index < images.length; index++) {
                    const element = images[index];
                    formData.append("media", element, element.name);
                }
            }
            formData.append("title", vidCaption);
            formData.append("taggedUsers", JSON.stringify(taggedUserList))
            formData.append("taggedEvents", JSON.stringify(taggedEventList));
            formData.append("communities", JSON.stringify(selectedCommunitiesList))
            formData.append("spaceId", spaceEnabled ? spaceId : "")
            formData.append("createdBy", selectedAccount)


            const token = localStorage.getItem("token");

            setLoading(true)

            const res = await fetch(`${BASE_URL}/uc/create-post`, {
                method: "POST",
                headers: {
                    "auth-token": token
                },
                body: formData
            });

            const data = await res.json();
            if (data.success) {
                alert(data.response)
            } else {
                alert(data.response);
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.error(error)
            alert("Something went wrong!")
        }

    };


    const getProfile = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/admin/view`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setUserProfile(data.response);
        }

    };

    useEffect(() => {
        async function getUserProfile() {
            const profile_obj = localStorage.getItem("profile")
            setUserProfile(JSON.parse(profile_obj))
        }
        getUserProfile()
        getProfile()
    }, []);
    const theme = useTheme();

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')



    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>

                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                    sx={{ flexWrap: 'wrap', flexDirection: 'row', gap: "10px" }}
                >
                    <Header
                        title={`Create a new post`}
                        subtitle={`Share/Create a post or crisp for any community`}
                    />

                </Box>

                <Box sx={{ flexDirection: "row", alignItems: "flex-start", display: "flex", flexWrap: "wrap", gap: "10px" }}>

                    <Box sx={{ flexDirection: "column", width: (isMobileScreen) ? "100%" : isTabScreen ? "60%" : "40%", gap: "10px", display: "flex" }} >

                        <Box
                            display="flex"
                            sx={{
                                px: '20px',
                                py: '20px',
                                borderRadius: "15px",
                                background: "#ffffff08",
                                alignSelf: "stretch",
                            }}>

                            <Box sx={{
                                display: "flex", flexDirection: "row", alignItems: "center",
                                background: "#ffffff10", borderRadius: "100px", padding: "5px"
                            }}>
                                {
                                    ["Post", "Crisp"].map((item, index) => (
                                        <Box key={item}
                                            onClick={() => {
                                                setSelectedTab(index)
                                            }}
                                            sx={{
                                                cursor: "pointer",
                                                flexDirection: "column", alignItems: "center", justifyContent: "center", display: "flex",
                                                backgroundColor: selectedTab == index ? "#943bff" : "#ffffff00", px: "25px",
                                                py: "5px", fontSize: "13px", color: "#ffffff", fontFamily: "poppins-reg", borderRadius: "100px"
                                            }} >
                                            {item}
                                        </Box>
                                    ))
                                }
                            </Box>



                        </Box>
                        <Box
                            display="flex"
                            sx={{
                                px: '20px',
                                py: '20px',
                                borderRadius: "15px",
                                background: "#ffffff08",
                                alignSelf: "stretch"
                            }}
                            flexDirection={'column'}
                        >


                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>

                                <FormControl margin="dense" required sx={{}}>
                                    <Select style={{
                                        fontFamily: 'poppins-reg', fontSize: "14px",
                                    }} sx={{
                                        fontFamily: "poppins-reg",
                                        fontSize: 14,

                                        // HEIGHT / PADDING
                                        "& .MuiSelect-select": {
                                            padding: "15px 18px",
                                            background: "#00000050",
                                            borderRadius: "10px",
                                        },

                                        // BORDER COLOR
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#aaaaaa10",
                                            borderRadius: "10px",
                                            borderWidth: "2px"
                                        },

                                        // HOVER
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#aaaaaa10",
                                            borderWidth: "2px"
                                        },

                                        // FOCUSED
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#aaaaaa30",
                                            borderWidth: "1px",
                                        },

                                        // TEXT COLOR
                                        color: "#ffffff",
                                    }}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    bgcolor: "#000000",
                                                    color: "#ffffff",
                                                    fontFamily: "poppins-reg"
                                                }
                                            },
                                        }} name="Select an account" value={selectedAccount} onChange={(value) => {
                                            setSelectedAccount(value.target.value)
                                            getMyCommunities(value.target.value)
                                        }} required>
                                        {
                                            availableAccounts.map((item) => (
                                                <MenuItem key={item.value} value={item.value} style={{
                                                    fontFamily: "poppins-reg", paddingBlock: "10px"
                                                }}>{item.title}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>

                            </Box>


                            {
                                ["67e5aba171c9cf306deba6ef", "64f38b069d6424868558af4f"].includes(selectedAccount) && (
                                    <Typography style={{
                                        fontSize: "12px",
                                        marginBottom: "10px",
                                        fontFamily: "poppins-reg", color: "orange", marginInline: "5px"
                                    }}>You selected a super account rather then Cerkle Campus, make sure you are doing right post using this selected account.</Typography>

                                )
                            }


                            {
                                selectedAccount != "id0" && (
                                    <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", mt: "10px" }}>

                                        <Box
                                            sx={{
                                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                position: 'relative',
                                                alignSelf: "flex-start",
                                                overflow: "hidden",
                                            }}>
                                            <img
                                                alt="profile-user"
                                                width="50px"
                                                height="50px"
                                                src={availableAccounts.find(d => d.value == selectedAccount)?.image ?? ""}
                                                style={{
                                                    objectFit: 'contain',
                                                    borderRadius: "50%",
                                                    border: "3px solid #ffffff10"
                                                }}
                                            />

                                        </Box>

                                        <Box sx={{ flexDirection: "column", flex: 1, display: "flex", ml: "10px" }}>

                                            <Typography style={{
                                                fontSize: "14px",
                                                fontFamily: "poppins-reg", color: "#ffffff",

                                            }}>{availableAccounts.find(d => d.value == selectedAccount).title}</Typography>

                                            <Typography style={{
                                                fontSize: "11px",
                                                fontFamily: "poppins-reg", color: "#ffffff90",

                                            }}>Posting on {Convert_Time_Zone(new Date().toISOString())}</Typography>


                                        </Box>


                                    </Box>
                                )
                            }


                            <Box sx={{
                                flexDirection: 'row',
                                backgroundColor: "#ffffff10",
                                display: 'flex',
                                mt: "10px",
                                borderRadius: "15px",
                                border: "2px solid #aaaaaa00",
                                background: "#00000050"
                            }}>

                                <textarea placeholder={selectedTab == 1 ? "Enter video caption..." : "Enter post description..."}
                                    rows={5}
                                    value={vidCaption}
                                    onChange={(v) => {
                                        setVidCaption(v.target.value)
                                    }}
                                    style={{
                                        outline: 'none',
                                        backgroundColor: "#aaaaaa00",
                                        borderWidth: 0,
                                        paddingLeft: "15px",
                                        paddingRight: "15px",
                                        paddingTop: "12px",
                                        flex: 1,
                                        display: 'flex',
                                        fontSize: "15px",
                                        paddingBottom: "12px",
                                        fontFamily: 'poppins-reg',
                                        color: "white"
                                    }} />



                            </Box>



                            {
                                selectedTab == 1 && (
                                    <Box

                                        sx={{
                                            flexDirection: "row", alignItems: "center",
                                            display: "flex", gap: "10px", mt: "10px"
                                        }} >

                                        <Box
                                            onClick={() => {
                                                videoInputRef?.current?.click()
                                            }}
                                            sx={{
                                                width: "150px",
                                                aspectRatio: "9/16",
                                                backgroundColor: "#00000050",
                                                border: "2px solid #aaaaaa10",
                                                borderRadius: "15px",
                                                gap: "5px",
                                                overflow: "hidden",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                alignItems: "center",
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "center"
                                            }}
                                        >

                                            <AddOutlined sx={{ color: "#ffffff" }} />

                                            <Typography style={{
                                                fontSize: "12px",
                                                fontFamily: "poppins-reg", color: "#ffffff",

                                            }}>Video</Typography>

                                            <Typography style={{
                                                fontSize: "11px",
                                                marginTop: "-5px",
                                                fontFamily: "poppins-reg", color: "#ffffff90",

                                            }}>{"Max size: 80MB"}</Typography>


                                            {
                                                selectedVideo?.name && (
                                                    <video
                                                        src={URL.createObjectURL(selectedVideo)}
                                                        controls={false}
                                                        autoPlay
                                                        loop
                                                        controlsList="nodownload"
                                                        onLoadedMetadata={(e) => {
                                                            setVideoDu(e.target.duration * 1000)
                                                        }}
                                                        muted
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            position: "absolute",
                                                            objectFit: "contain", // 🔥 key line
                                                        }}
                                                    />
                                                )
                                            }


                                            {
                                                selectedVideo?.name && (
                                                    <Box sx={{
                                                        flexDirection: "column", alignItems: "center", justifyContent: "center", display: "flex",
                                                        px: "8px", py: "2px", borderRadius: "100px", border: "1px solid #aaaaaa20",
                                                        backgroundColor: "#1b1b1b", position: "absolute", top: "5px", right: "5px"
                                                    }}>
                                                        <Typography style={{
                                                            fontSize: "10px",
                                                            fontFamily: "poppins-reg", color: "#ffffff",

                                                        }}>{"Video"}</Typography>
                                                    </Box>
                                                )}

                                        </Box>

                                        <Box
                                            onClick={() => {
                                                thumbInputRef?.current?.click()
                                            }}
                                            sx={{
                                                width: "150px",
                                                aspectRatio: "9/16",
                                                backgroundColor: "#00000050",
                                                border: "2px solid #aaaaaa10",
                                                borderRadius: "15px",
                                                gap: "5px",
                                                overflow: "hidden",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                alignItems: "center",
                                                display: "flex",
                                                position: "relative",
                                                justifyContent: "center"
                                            }}
                                        >

                                            <AddOutlined sx={{ color: "#ffffff" }} />

                                            <Typography style={{
                                                fontSize: "11px",
                                                fontFamily: "poppins-reg", color: "#ffffff",

                                            }}>Thumbnail</Typography>
                                            <Typography style={{
                                                fontSize: "11px",
                                                marginTop: "-5px",
                                                fontFamily: "poppins-reg", color: "#ffffff90",

                                            }}>{"Max size: 2MB"}</Typography>

                                            {
                                                selectedThumbnail?.name && (
                                                    <img
                                                        src={URL.createObjectURL(selectedThumbnail)} // your generated thumbnail
                                                        alt="video thumbnail"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            position: "absolute",
                                                            objectFit: "cover", // 🔥 same as video
                                                        }}
                                                    />
                                                )
                                            }

                                            {
                                                selectedThumbnail?.name && (
                                                    <Box sx={{
                                                        flexDirection: "column", alignItems: "center", justifyContent: "center", display: "flex",
                                                        px: "8px", py: "2px", borderRadius: "100px", border: "1px solid #aaaaaa20",
                                                        backgroundColor: "#1b1b1b", position: "absolute", top: "5px", right: "5px"
                                                    }}>
                                                        <Typography style={{
                                                            fontSize: "10px",
                                                            fontFamily: "poppins-reg", color: "#ffffff",

                                                        }}>{"Thumbnail"}</Typography>
                                                    </Box>
                                                )}

                                        </Box>

                                    </Box>
                                )
                            }

                            {
                                selectedTab == 0 && (
                                    <Box sx={{ flexDirection: "column", display: "flex", alignSelf: "stretch", marginTop: "10px" }}>

                                        <Box sx={{
                                            flexDirection: "row", alignItems: "center", display: "flex", alignSelf: "stretch", background: "#ffffff00",
                                            border: "2px solid #ffffff08",
                                            borderRadius: "15px", padding: "10px"
                                        }}>

                                            <Box sx={{ flexDirection: "column", flex: 1, display: "flex", marginInline: "5px" }}>
                                                <Typography style={{
                                                    fontFamily: "poppins-reg",
                                                    fontSize: "14px", color: "#ffffff"
                                                }} >Select post media</Typography>
                                                <Typography style={{
                                                    fontFamily: "poppins-reg",
                                                    fontSize: "11px",
                                                    color: "#ffffff80"
                                                }} >You can select upto 5 images.</Typography>
                                            </Box>
                                            <Box
                                                onClick={() => {
                                                    imageInputRef?.current?.click()
                                                }}
                                                sx={{
                                                    cursor: "pointer",
                                                    flexDirection: "column", alignItems: "center", justifyItems: "center", display: "flex",
                                                    fontFamily: "poppins-mid", fontSize: "12px", color: "#303030", paddingInline: "20px",
                                                    paddingBlock: "8px", background: "#ffffff", borderRadius: "10px"
                                                }} >Select Images</Box>

                                        </Box>

                                        <Box
                                            sx={{
                                                whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: "10px",
                                                scrollbarWidth: 'thin', // Firefox
                                                paddingBottom: "10px",
                                                mt: "10px",
                                                scrollbarColor: '#ffffff20 #000',

                                                '&::-webkit-scrollbar': {
                                                    height: '6px',
                                                },
                                                '&::-webkit-scrollbar-button': {
                                                    display: 'none',
                                                    width: 0,
                                                    height: 0,
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    backgroundColor: '#888', // 👈 make it visible first
                                                    borderRadius: '8px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    backgroundColor: '#00000020',
                                                },
                                            }} >

                                            {
                                                images.map((item, index) => (
                                                    <Box
                                                        sx={{
                                                            width: "160px",
                                                            minWidth: "160px",
                                                            aspectRatio: "9/13",
                                                            background: "#ffffff05",
                                                            borderRadius: "10px",
                                                            overflow: 'hidden',
                                                            border: "3px solid #ffffff05",
                                                            position: "relative"
                                                        }}
                                                    >


                                                        {
                                                            item?.name && (
                                                                <img
                                                                    src={URL.createObjectURL(item)} // your generated thumbnail
                                                                    alt="video thumbnail"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover", // 🔥 same as video
                                                                    }}
                                                                />
                                                            )
                                                        }

                                                        {
                                                            item?.name && (
                                                                <Box
                                                                    onClick={() => {
                                                                        setImages(prev => prev.filter(p => p.name != item.name))
                                                                    }}
                                                                    sx={{
                                                                        position: "absolute", display: "flex", top: 5, right: 5, background: "#943bff",
                                                                        borderRadius: "100px", padding: "6px", cursor: "pointer"
                                                                    }} >
                                                                    <CloseSharp style={{ fontSize: "15px", color: "#ffffff" }} />
                                                                </Box>
                                                            )
                                                        }

                                                    </Box>
                                                ))
                                            }

                                        </Box>

                                    </Box>
                                )
                            }



                        </Box>
                    </Box>

                    <Box
                        display="flex"
                        sx={{
                            px: '20px',
                            py: '20px',
                            borderRadius: "15px",
                            background: "#ffffff08",
                            width: (isMobileScreen) ? "100%" : isTabScreen ? "60%" : "40%",

                        }}
                        flexDirection={'column'}
                    >

                        <Box sx={{
                            display: "flex", flexDirection: "row", alignItems: "center",
                            alignSelf: "stretch", gap: "10px",
                        }} >

                            <Box
                                onClick={() => {
                                    setShowTaggedUserPopup(true)
                                }}
                                sx={{
                                    flexDirection: "column", display: "flex", flex: 1, backgroundColor: "#aaaaaa10",
                                    borderRadius: "10px", border: "0px solid #aaaaaa15", px: "15px", cursor: "pointer",
                                    py: "8px", position: "relative", alignItems: "center", justifyContent: "center"
                                }} >

                                <Typography style={{
                                    fontSize: "14px",
                                    fontFamily: "poppins-reg", color: "#ffffff",
                                    alignSelf: "stretch",
                                    userSelect: "none",
                                    msUserSelect: "none",
                                }}>Tagged Users</Typography>

                                <Typography style={{
                                    fontSize: "11px",
                                    fontFamily: "poppins-reg", color: "#ffffff90",
                                    alignSelf: "stretch",
                                    userSelect: "none",
                                    msUserSelect: "none",
                                }}>{taggedUsers.length} tagged</Typography>


                                <ArrowBackIos style={{ fontSize: "11px" }} sx={{ position: "absolute", right: 15, rotate: "180deg" }} />


                            </Box>

                            <Box
                                onClick={() => {
                                    setShowTaggedEventPopup(true)
                                }}
                                sx={{
                                    flexDirection: "column", display: "flex", flex: 1, backgroundColor: "#aaaaaa10",
                                    borderRadius: "10px", border: "0px solid #aaaaaa15", px: "15px", cursor: "pointer",
                                    py: "8px", position: "relative", alignItems: "center", justifyContent: "center"
                                }} >

                                <Typography style={{
                                    fontSize: "14px",
                                    fontFamily: "poppins-reg", color: "#ffffff",
                                    alignSelf: "stretch",
                                    userSelect: "none",
                                    msUserSelect: "none",
                                }}>Tagged Events</Typography>

                                <Typography style={{
                                    fontSize: "11px",
                                    fontFamily: "poppins-reg", color: "#ffffff90",
                                    alignSelf: "stretch",
                                    userSelect: "none",
                                    msUserSelect: "none",
                                }}>{taggedEvents.length} tagged</Typography>


                                <ArrowBackIos style={{ fontSize: "11px" }} sx={{ position: "absolute", right: 15, rotate: "180deg" }} />


                            </Box>


                        </Box>

                        <Box
                            onClick={() => {
                                setShowCMAddPopup(true)
                            }}
                            sx={{
                                flexDirection: "column", display: "flex", backgroundColor: "#aaaaaa10",
                                borderRadius: "10px", border: "2px solid #aaaaaa15", px: "15px", mt: "10px",
                                py: "8px", position: "relative", alignItems: "center", justifyContent: "center",
                                cursor: "pointer"
                            }} >

                            <Typography style={{
                                fontSize: "14px",
                                fontFamily: "poppins-reg", color: "#ffffff",
                                alignSelf: "stretch",
                                userSelect: "none",
                                msUserSelect: "none",
                            }}>Where this will be posted?</Typography>

                            <Typography style={{
                                fontSize: "12px",
                                fontFamily: "poppins-reg", color: "#ffffff90",
                                alignSelf: "stretch",
                                userSelect: "none",
                                msUserSelect: "none",
                            }}>{selectedCommunities.length == 0 ? "No" : selectedCommunities.length} {selectedCommunities.length <= 1 ? `community` : "communities"} selected</Typography>


                            <ArrowBackIos style={{ fontSize: "11px" }} sx={{ position: "absolute", right: 15, rotate: "180deg" }} />


                        </Box>

                        <Box sx={{
                            flexDirection: "row", display: "flex", backgroundColor: "#aaaaaa10",
                            borderRadius: "10px", border: "0px solid #ffffff10", px: "15px", mt: "10px",
                            py: "8px", position: "relative", alignItems: "center", justifyContent: "center",
                            cursor: "pointer"
                        }}>

                            <Box onClick={() => {
                                setSpaceEnabled(!spaceEnabled)
                            }} sx={{ display: "flex", flexDirection: 'column', flex: 1, cursor: 'pointer' }}>
                                <Typography
                                    sx={{
                                        userSelect: "none",
                                        msUserSelect: "none",
                                        fontSize: "14px",
                                        fontFamily: "poppins-reg", color: "#ffffff",
                                    }}>Share in Campus Space?</Typography>

                                <Typography sx={{
                                    color: "#ffffff90", fontSize: "12px",
                                    fontFamily: "poppins-reg",
                                    userSelect: "none",
                                    msUserSelect: "none",
                                }}>
                                    {spaceEnabled ? "This will be shared in cerkle campus also." : "This post will be hidden in cerkle campus."}
                                </Typography>
                            </Box>
                            <Switch
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#943bff', // track color when ON
                                    },
                                    '& .MuiSwitch-track': {
                                        backgroundColor: '#aaaaaa', // track color when OFF
                                    },
                                }}
                                style={{
                                    color: spaceEnabled ? "#943bff" : "#aaaaaa",
                                }} checked={spaceEnabled} onChange={(e) => setSpaceEnabled(e.target.checked)} />

                        </Box>


                        <Box
                            onClick={() => {
                                if (!loading) {
                                    if (selectedTab == 0) {
                                        uploadPost()
                                    } else {
                                        uploadLogo()
                                    }
                                }
                            }}
                            sx={{
                                flexDirection: "row", display: "flex", backgroundColor: "#943bff",
                                borderRadius: "100px", border: "1px solid #aaaaaa15", px: "10px", mt: "50px",
                                cursor: "pointer",
                                py: "15px", position: "relative", alignItems: "center", justifyContent: "center", gap: "5px"
                            }}>

                            {
                                !loading && (
                                    <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center", gap: "5px", justifyContent: "center" }}>
                                        <Typography style={{
                                            fontSize: "14px",
                                            fontFamily: "poppins-reg", color: "#ffffff",
                                        }}>Upload and Share</Typography>

                                        <Send sx={{ fontSize: "15px" }} />
                                    </Box>
                                )
                            }


                            {
                                loading && (
                                    <Box sx={{ position: "absolute" }}>
                                        <MoonLoader size={"20px"} color={"#ffffff"} />
                                    </Box>
                                )
                            }



                        </Box>

                    </Box>

                </Box>




                <input
                    type="file"
                    accept="video/*"
                    hidden
                    ref={videoInputRef}
                    onChange={(e) => {
                        console.log(e.target.files[0])
                        const file = e.target.files[0]
                        const sizeInMb = file.size / (1024 * 1024)
                        if (sizeInMb >= 80) {
                            alert("Please select a video below 80 MB size")
                            return
                        } else {
                            setSelectedVideo(e.target.files[0])
                        }
                    }}
                />

                <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    hidden
                    multiple
                    ref={imageInputRef}
                    onChange={handleChange}
                />


                <input
                    type="file"
                    accept="image/*"
                    hidden
                    ref={thumbInputRef}
                    onChange={(e) => {
                        console.log(e.target.files[0])
                        const file = e.target.files[0]
                        const sizeInMb = file.size / (1024 * 1024)
                        if (sizeInMb >= 2) {
                            alert("Please select a video below 2 MB size")
                            return
                        } else {
                            setSelectedThumbnail(e.target.files[0])
                        }
                    }}
                />

                <AddUsersPopup
                    open={showTaggedUserPopup}
                    onClose={() => {
                        setUserQuery("")
                        setSearchedUsers([])
                        setShowTaggedUserPopup(false)
                    }}

                >

                    <Box sx={{ flexDirection: 'column', display: 'flex' }} >
                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            borderRadius: "15px",
                            border: "1px solid transparent",
                            background:
                                "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#ffffff30, #00000000) border-box"
                        }}>
                            <img
                                alt="search_icon"
                                width="18px"
                                height="18px"
                                style={{
                                    objectFit: 'contain',
                                    filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                                    alignSelf: 'center',
                                    marginLeft: "15px"
                                }}
                                src={searchIcon}
                            />
                            <input placeholder="Search by name or username"
                                multiple={false}
                                value={userQuery}
                                onChange={(v) => {
                                    setUserQuery(v.target.value)
                                }}
                                style={{
                                    outline: 'none',
                                    backgroundColor: "#aaaaaa00",
                                    borderWidth: 0,
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingTop: "10px",
                                    flex: 1,
                                    display: 'flex',
                                    fontSize: "15px",
                                    paddingBottom: "10px",
                                    fontFamily: 'poppins-reg',
                                    borderRadius: "100px",
                                    color: "white"
                                }} />


                        </Box>

                        <Box sx={{ minHeight: "350px", maxHeight: "450px", display: 'flex', flexDirection: 'column' }}>

                            {
                                [...userQuery.length > 0 ? searchedUsers : taggedUsers].map((item, index) => (
                                    <Box
                                        onClick={() => {
                                            const exists = taggedUsers.some(tu => tu._id === item._id)
                                            if (exists) {
                                                const newList = taggedUsers.filter(tu => tu._id != item._id)
                                                setTaggedUsers(newList)
                                            } else {
                                                setTaggedUsers(prev => [...prev, item])
                                            }
                                        }}
                                        display="flex"
                                        alignItems="center"
                                        px="15px"
                                        py={"8px"}
                                        sx={{
                                            textDecoration: 'none', paddingY: "10px", flexDirection: 'row', alignItems: 'center',
                                            display: 'flex', borderBottom: "1px solid #aaaaaa10"
                                        }}
                                    >
                                        <Box

                                            sx={{
                                                textDecoration: 'none', flex: 1, flexDirection: 'row', alignItems: 'center',
                                                display: 'flex',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <img
                                                    alt="profile-user"
                                                    width="40px"
                                                    height="40px"
                                                    src={`${item?.image?.[0]}`}
                                                    style={{
                                                        cursor: "pointer", objectFit: 'cover',
                                                        borderRadius: "50%",
                                                        border: "3px solid #ffffff10"
                                                    }}
                                                />
                                            </Box>
                                            <Box sx={{ ml: "20px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{item?.full_name}</Typography>

                                                <Box sx={{
                                                    display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "4px",
                                                    gap: "5px"
                                                }}>
                                                    <Typography color={"#ffffffff"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            borderRadius: "4px",
                                                            background: "#ffffff20",
                                                            paddingTop: "2px",
                                                            paddingBottom: "2px",
                                                            paddingLeft: "8px",
                                                            paddingRight: "8px"
                                                        }}
                                                        fontSize={"10.5px"}>{item?.buzz_name}</Typography>
                                                </Box>
                                            </Box>

                                            <FormControlLabel
                                                value={item._id}
                                                control={
                                                    <Checkbox
                                                        checked={taggedUsers.some(cc => cc._id == item._id)}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            if (e.target.checked) {
                                                                if (!taggedUsers.some(cc => cc._id == item._id)) {
                                                                    const newList = [...taggedUsers, item]
                                                                    setTaggedUsers(newList)
                                                                }
                                                            } else {
                                                                if (taggedUsers.some(cc => cc._id == item._id)) {
                                                                    const filteredList = taggedUsers.filter(ct => ct._id != item._id)
                                                                    setTaggedUsers(filteredList)
                                                                }
                                                            }

                                                        }}
                                                        sx={{
                                                            color: "#666",                    // unselected
                                                            "&.Mui-checked": {
                                                                color: "#943bff"                // selected
                                                            },
                                                            "&:hover": { backgroundColor: "rgba(0,224,255,0.08)" }
                                                        }}
                                                    />
                                                }
                                                sx={{
                                                    m: 0,
                                                    alignItems: "center",
                                                    ".MuiFormControlLabel-label": {
                                                        fontFamily: "poppins-reg",
                                                        fontSize: 13,
                                                        lineHeight: "20px",
                                                        color: "#ddd",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }
                                                }}
                                            />


                                        </Box>


                                    </Box>
                                ))
                            }

                        </Box>

                    </Box>


                </AddUsersPopup>

                <AddEventPopup
                    open={showTaggedEventPopup}
                    onClose={() => {
                        setEventQuery("")
                        setSearchedEvents([])
                        setShowTaggedEventPopup(false)
                    }}
                >
                    <Box sx={{ flexDirection: 'column', display: 'flex' }} >
                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            borderRadius: "15px",
                            border: "1px solid transparent",
                            background:
                                "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#ffffff30, #00000000) border-box"
                        }}>
                            <img
                                alt="search_icon"
                                width="18px"
                                height="18px"
                                style={{
                                    objectFit: 'contain',
                                    filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                                    alignSelf: 'center',
                                    marginLeft: "15px"
                                }}
                                src={searchIcon}
                            />
                            <input placeholder="Search by event name"
                                multiple={false}
                                value={eventQuery}
                                onChange={(v) => {
                                    setEventQuery(v.target.value)
                                }}
                                style={{
                                    outline: 'none',
                                    backgroundColor: "#aaaaaa00",
                                    borderWidth: 0,
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingTop: "10px",
                                    flex: 1,
                                    display: 'flex',
                                    fontSize: "15px",
                                    paddingBottom: "10px",
                                    fontFamily: 'poppins-reg',
                                    borderRadius: "100px",
                                    color: "white"
                                }} />


                        </Box>

                        <Box sx={{ minHeight: "350px", maxHeight: "450px", display: 'flex', flexDirection: 'column' }}>

                            {
                                [...eventQuery.length > 0 ? searchedEvents : taggedEvents].map((item, index) => (
                                    <Box
                                        onClick={() => {
                                            const exists = taggedEvents.some(tu => tu._id === item._id)
                                            if (exists) {
                                                const newList = taggedEvents.filter(tu => tu._id != item._id)
                                                setTaggedEvents(newList)
                                            } else {
                                                setTaggedEvents(prev => [...prev, item])
                                            }
                                        }}
                                        display="flex"
                                        alignItems="center"
                                        px="15px"
                                        py={"8px"}
                                        sx={{
                                            textDecoration: 'none', paddingY: "10px", flexDirection: 'row', alignItems: 'center',
                                            display: 'flex', borderBottom: "1px solid #aaaaaa10"
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                textDecoration: 'none', flex: 1, flexDirection: 'row', alignItems: 'center',
                                                display: 'flex',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <img
                                                    alt="profile-user"
                                                    width="40px"
                                                    height="40px"
                                                    src={`${item?.banner}`}
                                                    style={{
                                                        cursor: "pointer", objectFit: 'cover',
                                                        borderRadius: "50%",
                                                        border: "3px solid #ffffff10"
                                                    }}
                                                />
                                            </Box>
                                            <Box sx={{ ml: "20px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{item?.title}</Typography>

                                                <Box sx={{
                                                    display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "4px",
                                                    gap: "5px"
                                                }}>
                                                    <Typography color={"#ffffffff"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            borderRadius: "4px",
                                                            background: "#ffffff20",
                                                            paddingTop: "2px",
                                                            paddingBottom: "2px",
                                                            paddingLeft: "8px",
                                                            paddingRight: "8px"
                                                        }}
                                                        fontSize={"10.5px"}>{item?.eventType}</Typography>
                                                </Box>
                                            </Box>

                                            <FormControlLabel
                                                value={item._id}
                                                control={
                                                    <Checkbox
                                                        checked={taggedEvents.some(cc => cc._id == item._id)}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            if (e.target.checked) {
                                                                if (!taggedEvents.some(cc => cc._id == item._id)) {
                                                                    const newList = [...taggedEvents, item]
                                                                    setTaggedEvents(newList)
                                                                }
                                                            } else {
                                                                if (taggedEvents.some(cc => cc._id == item._id)) {
                                                                    const filteredList = taggedEvents.filter(ct => ct._id != item._id)
                                                                    setTaggedEvents(filteredList)
                                                                }
                                                            }

                                                        }}
                                                        sx={{
                                                            color: "#666",                    // unselected
                                                            "&.Mui-checked": {
                                                                color: "#943bff"                // selected
                                                            },
                                                            "&:hover": { backgroundColor: "rgba(0,224,255,0.08)" }
                                                        }}
                                                    />
                                                }
                                                sx={{
                                                    m: 0,
                                                    alignItems: "center",
                                                    ".MuiFormControlLabel-label": {
                                                        fontFamily: "poppins-reg",
                                                        fontSize: 13,
                                                        lineHeight: "20px",
                                                        color: "#ddd",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }
                                                }}
                                            />


                                        </Box>


                                    </Box>
                                ))
                            }

                        </Box>

                    </Box>


                </AddEventPopup>

                <SelectCommunitiesPopup
                    open={showCMAddPopup}
                    onClose={() => setShowCMAddPopup(false)} onDelete={() => {
                        //removeCommunity(selectedCommunity._id)
                    }} >

                    <Box sx={{ flexDirection: 'column', display: 'flex' }} >
                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            borderRadius: "15px",
                            border: "1px solid transparent",
                            background:
                                "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#ffffff30, #00000000) border-box"
                        }}>
                            <img
                                alt="search_icon"
                                width="18px"
                                height="18px"
                                style={{
                                    objectFit: 'contain',
                                    filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                                    alignSelf: 'center',
                                    marginLeft: "15px"
                                }}
                                src={searchIcon}
                            />
                            <input placeholder="Search community..."
                                multiple={false}
                                value={communityQuery}
                                onChange={(v) => {
                                    setCommunityQuery(v.target.value)
                                }}
                                style={{
                                    outline: 'none',
                                    backgroundColor: "#aaaaaa00",
                                    borderWidth: 0,
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingTop: "10px",
                                    flex: 1,
                                    display: 'flex',
                                    fontSize: "15px",
                                    paddingBottom: "10px",
                                    fontFamily: 'poppins-reg',
                                    borderRadius: "100px",
                                    color: "white"
                                }} />


                        </Box>

                        <Box sx={{ minHeight: "350px", display: 'flex', flexDirection: 'column', overflow: "scroll", maxHeight: "60vh" }}>

                            {
                                (communityQuery.length > 0 ? searchedCommunities : myCommunities).map((community, index) => (
                                    <Box
                                        onClick={() => {
                                            setSelectedCommunities(prev => {
                                                const exists = prev.some(
                                                    cc => cc._id.toString() === community._id.toString()
                                                );

                                                if (exists) {
                                                    return prev.filter(
                                                        ct => ct._id.toString() !== community._id.toString()
                                                    );
                                                }

                                                return [...prev, community];
                                            });
                                        }}
                                        display="flex"
                                        alignItems="center"
                                        px="0px"
                                        py={"10px"}
                                        sx={{
                                            textDecoration: 'none', paddingY: "10px", flexDirection: 'row', alignItems: 'center',
                                            display: 'flex', borderBottom: "1px solid #aaaaaa10", marginTop: index == 0 ? "10px" : "0"
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                textDecoration: 'none', flex: 1, flexDirection: 'row', alignItems: 'center',
                                                display: 'flex',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <img
                                                    alt="profile-user"
                                                    width="40px"
                                                    height="40px"
                                                    src={`${community.logo}`}
                                                    style={{
                                                        cursor: "pointer", objectFit: 'cover',
                                                        borderRadius: "50%",
                                                        border: "3px solid #ffffff10"
                                                    }}
                                                />
                                            </Box>
                                            <Box sx={{ ml: "10px", mr: "10px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, position: 'relative' }}>

                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    fontSize={"12px"} style={{
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 1,      // change to 3,4 if needed
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden"
                                                    }} >{community.title}</Typography>

                                                <Box sx={{
                                                    display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "4px",
                                                    gap: "5px"
                                                }}>
                                                    <Typography color={"#aaaaaa"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            borderRadius: "4px",
                                                            background: "#ffffff10",
                                                            paddingTop: "2px",
                                                            paddingBottom: "2px",
                                                            paddingLeft: "5px",
                                                            paddingRight: "5px"
                                                        }}
                                                        fontSize={"10.5px"}>{community.communityType}</Typography>
                                                </Box>
                                            </Box>

                                            <FormControlLabel
                                                value={community._id}
                                                control={
                                                    <Checkbox
                                                        checked={selectedCommunities.some(cc => cc._id == community._id)}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            if (e.target.checked) {
                                                                if (!selectedCommunities.some(cc => cc._id == community._id)) {
                                                                    const newList = [...selectedCommunities, community]
                                                                    setSelectedCommunities(newList)
                                                                }
                                                            } else {
                                                                if (selectedCommunities.includes(community._id)) {
                                                                    const filteredList = selectedCommunities.filter(ct => ct._id != community._id)
                                                                    setSelectedCommunities(filteredList)
                                                                }
                                                            }

                                                        }}
                                                        sx={{
                                                            color: "#666",                    // unselected
                                                            "&.Mui-checked": {
                                                                color: "#943bff"                // selected
                                                            },
                                                            "&:hover": { backgroundColor: "rgba(0,224,255,0.08)" }
                                                        }}
                                                    />
                                                }
                                                sx={{
                                                    m: 0,
                                                    alignItems: "center",
                                                    ".MuiFormControlLabel-label": {
                                                        fontFamily: "poppins-reg",
                                                        fontSize: 13,
                                                        lineHeight: "20px",
                                                        color: "#ddd",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }
                                                }}
                                            />

                                        </Box>


                                    </Box>
                                ))
                            }

                        </Box>

                    </Box>



                </SelectCommunitiesPopup>

            </Box >
        </>
    );
}

export default CreatePostScreen;
